import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import { SuggestionModel } from '../suggestion-model';
import type { SuggestionState } from '../../types';

function createSuggestionState(): SuggestionState {
    return {
        isLoading: true,
        techTopic: '',
        suggestions: [],
        activeSuggestionIdx: 0,
    };
}

@injectable()
export class SuggestionModelImpl extends AbstractModel<SuggestionState> implements SuggestionModel {
    protected _modelData: SuggestionState = createSuggestionState();

    dispose() {
        this.update(() => {
            return createSuggestionState();
        });
    }
}
